export default __webpack_public_path__ + "static/media/quote-icon-4-black.c0523f8e.svg";